// extracted by mini-css-extract-plugin
module.exports = {"checkBox":"Checkbox2StatesWidget_checkBox__3-dcj","disabled":"Checkbox2StatesWidget_disabled__3eVZR"};